<input
  #fileInput
  [id]="inputId()"
  type="file"
  [multiple]="multiple()"
  class="d-none"
  (change)="onBrowseFiles($event)"
/>
<div
  class="upload-dropzone d-flex flex-column align-items-center justify-content-center text-center p-4"
  [class.border-primary]="isDragOver()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="fileInput.click()"
  tabindex="0"
  (keydown.enter)="fileInput.click()"
  (keydown.space)="fileInput.click()"
>
  <i [class]="'mb-2 fs-1 ' + iconClass()"></i>
  <p class="mb-1">{{ primaryText() }}</p>
  @if (secondaryText()) {
    <small class="text-muted">{{ secondaryText() }}</small>
  }
</div>
